// Fix per gli errori di comunicazione del PayPal SDK

(function() {
    'use strict';
    
    // Applica il fix solo se non è già stato applicato
    if (window.paypalFixApplied) return;
    
    // Cache delle funzioni originali
    const originalMethods = {
        consoleError: console.error,
        consoleWarn: console.warn,
        setTimeout: window.setTimeout,
        postMessage: window.postMessage
    };

    // Pattern regex per errori PayPal
    const paypalErrorPatterns = [
        /paypal_js_sdk_v5_unhandled_exception/i,
        /no ack for postmessage/i,
        /kn\(\)/i,
        /in\(\)/i,
        /oninit\(\)/i,
        /getpageurl\(\)/i,
        /paypal_js_sdk_v5/i,
        /postmessage/i
    ];

    // Funzione per verificare se un messaggio è correlato a PayPal
    function isPaypalMessage(message) {
        const messageString = typeof message === 'string' ? message : String(message);
        return paypalErrorPatterns.some(pattern => pattern.test(messageString));
    }

    // Funzione per sopprimere gli errori specifici del PayPal SDK
    function suppressPaypalErrors() {
        console.error = function(...args) {
            const message = args[0];
            if (typeof message === 'string' && isPaypalMessage(message)) {
                console.info('[PayPal SDK] Communication error suppressed:', message.substring(0, 100) + '...');
                return;
            }
            return originalMethods.consoleError.apply(console, args);
        };
        
        console.warn = function(...args) {
            const message = args[0];
            if (typeof message === 'string' && isPaypalMessage(message)) {
                return; // Sopprimi i warning del PayPal SDK
            }
            return originalMethods.consoleWarn.apply(console, args);
        };
    }
    
    // Funzione per gestire i timeout del PayPal SDK
    function handlePaypalTimeouts() {
        window.setTimeout = function(callback, delay, ...args) {
            // Probabile timeout del PayPal SDK, aumenta il delay
            if (delay === 10000 && callback.toString().includes('postMessage')) {
                return originalMethods.setTimeout.call(window, callback, 20000, ...args);
            }
            return originalMethods.setTimeout.call(window, callback, delay, ...args);
        };
    }
    
    // Funzione per migliorare la gestione degli iframe del PayPal
    function improvePaypalIframeHandling() {
        // Ascolta gli errori degli iframe
        window.addEventListener('error', function(event) {
            if (event.filename && event.filename.includes('paypal.com')) {
                event.preventDefault();
                event.stopPropagation();
                console.info('[PayPal SDK] Iframe error handled');
                return false;
            }
        }, true);
        
        // Ascolta gli errori non gestiti
        window.addEventListener('unhandledrejection', function(event) {
            if (event.reason && typeof event.reason === 'string' && 
                isPaypalMessage(event.reason)) {
                event.preventDefault();
                console.info('[PayPal SDK] Unhandled rejection prevented');
                return false;
            }
        });
    }
    
    // Funzione per patchare le funzioni postMessage
    function patchPostMessage() {
        window.postMessage = function(message, targetOrigin, transfer) {
            try {
                return originalMethods.postMessage.call(this, message, targetOrigin, transfer);
            } catch (error) {
                if (error.message && isPaypalMessage(error.message)) {
                    console.info('[PayPal SDK] PostMessage error handled');
                    return;
                }
                throw error;
            }
        };
    }
    
    // Inizializza tutti i fix
    function initPaypalFixes() {
        suppressPaypalErrors();
        handlePaypalTimeouts();
        improvePaypalIframeHandling();
        patchPostMessage();
        
        window.paypalFixApplied = true;
        console.info('[PayPal SDK] Fixes applied successfully');
    }
    
    // Applica i fix quando il DOM è pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPaypalFixes);
    } else {
        initPaypalFixes();
    }
    
    // Applica i fix anche se il PayPal SDK viene caricato dopo
    let checkCount = 0;
    const maxChecks = 50;
    const checkInterval = setInterval(() => {
        checkCount++;
        if (window.paypal || window.paypalPal || document.querySelector('[data-paypal-sdk]')) {
            initPaypalFixes();
            clearInterval(checkInterval);
        } else if (checkCount >= maxChecks) {
            clearInterval(checkInterval);
        }
    }, 200);
    
})();